import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

const field = (key: string) => `${sel("preferenceField")}[data-pref="${key}"]`;

/**
 * Academy lesson: set up your report preferences. Started from the lesson page
 * in a new tab; never auto-started. Nothing is saved unless the officer
 * clicks Save Preferences themselves.
 */
const tour: TutorialDefinition = {
  id: "set-up-your-report-preferences",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Set up your report preferences",
  description: "Set your name, rank, perspective, and formats before your first draft.",
  triggerRoute: /^\/preferences$/,
  startRoute: "/cases",
  lessonId: "set-up-your-report-preferences",
  autoStart: false,
  steps: [
    {
      target: sel("preferencesButton"),
      title: "Open Report Preferences",
      content: "Click the sliders icon next to New Case.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("preferencesButton"), event: "click" },
      hint: "Click the sliders icon to continue",
      spotlightClicks: true,
    },
    {
      target: field("name"),
      waitFor: field("name"),
      waitTimeoutMs: 10000,
      title: "Who the report says you are",
      content: "Include Name, Include Rank/Title, and Include Badge Number tell the AI how to refer to you. Check each one.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: field("perspective"),
      waitFor: field("perspective"),
      title: "Narrative Perspective",
      content: "First person says \"I\", third person says \"Officer Smith\". Subject Reference Style, just below, controls how victims, suspects, and witnesses are named after the first mention.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: field("time_format"),
      waitFor: field("time_format"),
      title: "Date and time formats",
      content: "Set Date Format and Time Format to match how your department writes reports.",
      disableBeacon: true,
      placement: "top",
    },
    {
      target: sel("preferencesSave"),
      waitFor: sel("preferencesSave"),
      title: "Save Preferences",
      content: "Changes apply to new drafts and to any report you regenerate. Click Save Preferences when you are done.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
